<template>
    <div class="custmor-tranSheet-box">
        <HeaderNav
            header-title="运输单列表"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <!-- <div class="search-con">
            <van-search placeholder="请输入搜索关键词"></van-search>
        </div> -->
        <div class="warpper">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                v-if="total"
            >
                <template v-for="(item, index) in materialPlanList">
                    <div
                        class="materialPlan-item saved van-clearfix"
                        :key="index"
                        @click="toElectronicTicket(item)"
                    >
                        <ul>
                            <li class="tit">
                                <span class="iconfont icondanjubianhao"></span>
                                <span class="info">运单编号：{{ item.pcb_number }}</span>
                            </li>
                            <li>
                                <span class="pre-icon materialPlan01"></span>
                                <span class="info">车牌号：{{ item.plate_number }}</span>
                            </li>
                            <li>
                                <van-row>
                                    <van-col span="12">
                                        <span class="pre-icon materialPlan02"></span>
                                        <span class="info">运输方量：{{ item.volume }}方</span>
                                    </van-col>
                                    <van-col span="12">
                                        <span class="pre-icon materialPlan03"></span>
                                        <span class="info">强度等级：{{ item.strength_grade_name }}</span>
                                    </van-col>
                                </van-row>
                            </li>
                            <li>
                                <span class="pre-icon materialPlan04"></span>
                                <span class="info">始卸时间：{{ item.unload_time }}</span>
                            </li>
                            <li>
                                <span class="pre-icon materialPlan05"></span>
                                <span class="info">毕卸时间：{{ item.unload_over_time }}</span>
                            </li>
                        </ul>
                        <div class="sign-btn sign-btn-overed" v-if="item.client_eva" @click.stop="toEvaluate(item, 'over')">
                            已签收
                        </div>
                        <div class="sign-btn" v-else @click.stop="toEvaluate(item, 'new')">
                            立即签收
                        </div>
                    </div>
                </template>
            </van-list>
            <div class="no-data" v-else></div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            materialPlanList: [],
            pagetion: {
                pageindex: 0,
                pagesize: 3,
            },
            loading: false,
            finished: false,
            total: true, // 是否有数据
        };
    },
    methods: {
        onLoad() {
            this.pagetion.pageindex++;
            const MobilePhone = this.$takeTokenParameters('MobilePhone');
            this.$axios
                .get('/interfaceApi/production/productpcb/page_client?phone=' + MobilePhone
                + '&type=0&pageindex=' + this.pagetion.pageindex + '&pagesize=' + this.pagetion.pagesize)
                .then(res => {
                    this.loading = false;
                    this.total = res.total;
                    if (res.total) {
                        this.materialPlanList = this.materialPlanList.concat(res.rows);
                        if (this.materialPlanList.length >= res.total) {
                            this.finished = true;
                        }
                    } else {
                        this.finished = true;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 通过订单编号获取
        getDriver() {
            const MobilePhone = this.$takeTokenParameters('MobilePhone');
            this.$axios
                .get('/interfaceApi/production/productpcb/page_client?phone=' + MobilePhone
                + '&type=0&pageindex=' + this.pagetion.pageindex + '&pagesize=' + this.pagetion.pagesize)
                .then(res => {
                    if (res.total) {
                        this.materialPlanList = res.rows;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 评价
        toEvaluate(data, type) {
            this.$router.isBack = 2;
            if (type === 'new') {
                this.$router.push({ name: 'newTransSheet', params: { pcb_number: data.pcb_number } });
            } else {
                this.$router.push({ name: 'transSheetInfo', params: { pcb_number: data.pcb_number } });
            }

        },
        // 展示电子运单
        toElectronicTicket(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'electronicTicket', params: { pcb_number: data.pcb_number } });
        },
    },
    created() {
        // this.getDriver();
    },
};
</script>

<style lang="stylus">
.custmor-tranSheet-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .newPlan
        position fixed
        right 20rpx
        top 10rpx
        z-index 1000
        color #fff
    .search-con
        .van-search
            background #F0F0F0!important
    .warpper
        height 100%
        background #F0F0F0
        overflow-y auto
        padding 12rpx 12rpx 12rpx 12rpx
        .materialPlan-item
            width 100%
            background #ffffff
            margin-bottom 15rpx
            position relative
            overflow hidden
            padding 10rpx
            color #666666
            font-size 14rpx
            li
                overflow hidden
                margin-bottom 10rpx
                line-height 22rpx
                .pre-icon
                    width 18rpx
                    height 18rpx
                    display inline-block
                    vertical-align middle
                    margin-right 5rpx
                    &:before
                        content ' '
                        width 16rpx
                        height 16rpx
                        display inline-block
                        background-repeat no-repeat
                        background-size 100% 100%
                    &.materialPlan01
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_9.png)
                    &.materialPlan02
                        &:before
                            background-image url(./../../../assets/images/icons/icon_30.png)
                    &.materialPlan03
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_1.png)
                    &.materialPlan04
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_7.png)
                    &.materialPlan05
                        &:before
                            background-image url(./../../../assets/images/icons/icon_gy_7.png)
                &.tit
                    font-size 16rpx
                    color #061F3E
                    .icondanjubianhao
                        font-size 18rpx
                        margin 3rpx 5rpx 0 0
            &.saved
                .tit
                    .icondanjubianhao
                        color #0189FC
                .corner-marker
                    background #0189FC
            .sign-btn
                position absolute
                right 10rpx
                bottom 10rpx
                width 70rpx;
                height 25rpx;
                border 1px solid #FF6600
                border-radius 12rpx;
                text-align center
                color #FF6600
                font-size 12rpx
                line-height 25rpx
                &.sign-btn-overed
                    border 1px solid #00A84B
                    color #00A84B

</style>